<template>
  <div>
    {{ cred.label }}:&nbsp;&nbsp;
    <a v-if="cred.type == 'url'" :href="cred.value">Click Here</a>
    <span v-if="cred.type == 'text'" class="font-weight-bold">{{ cred.value }}</span>
  </div>
</template>

<script>

export default {
  name: 'RewardCredential',

  props: ['cred'],
}
</script>